import { render, staticRenderFns } from "./ConfirmDeclineModal.vue?vue&type=template&id=36c8052b&"
import script from "./ConfirmDeclineModal.vue?vue&type=script&lang=js&"
export * from "./ConfirmDeclineModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports